var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-application" },
    [
      _c(
        "v-snackbar",
        {
          class: ["success", "error", "warning"].includes(_vm.snackbar.color)
            ? "black--text"
            : "",
          attrs: {
            timeout: _vm.snackbar.timeout,
            right: "",
            color: _vm.snackbar.color
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                (_vm.snackbar.text || "").replace(/\n/g, "<br>")
              )
            }
          }),
          _vm.snackbar.button
            ? _c(
                "v-btn",
                {
                  class: ["success", "error", "warning"].includes(
                    _vm.snackbar.color
                  )
                    ? "black--text"
                    : "",
                  attrs: {
                    color: _vm.snackbar.button.color || "white",
                    text: ""
                  },
                  on: {
                    click: function() {
                      _vm.show = false
                      if (_vm.snackbar.button.callback) {
                        _vm.snackbar.button.callback()
                      }
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.snackbar.button.text || "Fechar") + " "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }